var _path, _path2, _ellipse;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.423,
    height: 29.423,
    viewBox: "0 0 29.423 29.423",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.658,0H8.765A8.775,8.775,0,0,0,0,8.765V20.658a8.775,8.775,0,0,0,8.765,8.765H20.658a8.775,8.775,0,0,0,8.765-8.765V8.765A8.775,8.775,0,0,0,20.658,0Zm5.805,20.658a5.805,5.805,0,0,1-5.805,5.805H8.765A5.805,5.805,0,0,1,2.96,20.658V8.765A5.805,5.805,0,0,1,8.765,2.96H20.658a5.805,5.805,0,0,1,5.805,5.805V20.658Z",
    transform: "translate(0)",
    fill: "#757575"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M140.61,133a7.61,7.61,0,1,0,7.61,7.61A7.618,7.618,0,0,0,140.61,133Zm0,12.26a4.65,4.65,0,1,1,4.65-4.65A4.65,4.65,0,0,1,140.61,145.26Z",
    transform: "translate(-125.898 -125.898)",
    fill: "#757575"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.823,
    cy: 1.823,
    rx: 1.823,
    ry: 1.823,
    transform: "translate(20.512 5.335)",
    fill: "#757575"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIg);
export default __webpack_public_path__ + "static/media/ig.93b3193189128b4bc8d0a2f8a74ace5a.svg";
export { ForwardRef as ReactComponent };